<template>
  <div></div>
</template>
<script>
export default {
  name: 'SettingsTabSessions'
}
</script>
<style>
</style>
